@use "styles" as *;

.me-appearance-options {
  display: flex;
  align-items: center;

  &__font-size-symbol {
    &--r {
      margin-left: space(-4);
    }

    &--r .me-button__label {
      font-size: $font-size-r;
    }

    &--xl .me-button__label {
      font-size: $font-size-xl;
    }

    &.me-button--r {
      padding: space(4, 4);
    }
  }

  &__font-size-range {
    flex: 1;
    accent-color: $color-text-primary;
    width: 100%;
  }

  &__mode {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: space(1);
    margin-left: space(4);
  }

  .me-separator {
    align-self: stretch;
    height: auto;
  }
}
